import './OrderDetail.scss'

import { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSetAtom } from 'jotai'

import { getUserStatus } from 'src/pages/membership/components/MembershipBenefits/utils'
import { useMembershipData } from 'src/api/Membership/useMembershipData'
import { membershipModalAtom } from 'src/atoms/modals/membershipModal.atom'
import { MEMBERSHIP_MODAL_STEPS } from 'src/modules/Modals/constants'
import {
  getMembershipDiscount,
  getOrderViewComponents
} from 'src/redux-api-bridge/order/selectors'
import { fetchOrderDetailV2 } from 'src/redux-api-bridge/order/effects'
import { useMembershipWhitelist } from 'src/pages/membership/useMembershipWhitelist'
import { SubscriptionPriceRenewalInfoBanner } from './SubscriptionPriceRenewalInfoBanner/SubscriptionPriceRenewalInfoBanner'
import { UXComponentRenderer } from 'src/componentsV2/CoreUX/UXComponentRenderer/UXComponentRenderer'
import { UXComponent } from 'src/componentsV2/CoreUX/UXComponentRenderer/uxComponent'

interface Props {
  meals: any[]
  addons: any[]
  plan: any
}

export const OrderDetail: FC<Props> = ({ meals, addons }) => {
  const dispatch = useDispatch()
  const isUserEligibleForMembership = useMembershipWhitelist()
  const membershipDiscount = useSelector(getMembershipDiscount)
  const { membershipData } = useMembershipData()
  const setMembership = useSetAtom(membershipModalAtom)
  const membershipStatus = getUserStatus(membershipData?.activation)

  const view = useSelector(getOrderViewComponents) as Array<UXComponent>

  function openMembershipCheckoutModal() {
    setMembership(prev => ({
      ...prev,
      isOpen: true,
      step: MEMBERSHIP_MODAL_STEPS.checkout
    }))
  }

  useEffect(() => {
    const items = [...meals, ...addons]
    const mapMeals = (meal: any) => ({
      entityId: meal.entity_id,
      quantity: meal.qty,
      inventoryId: meal.inventoryId
    })

    dispatch(fetchOrderDetailV2(items.map(mapMeals)))
    // FIXME This actually needs to be fixed, meals and addons should be in deps array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meals.length, addons.length])

  return (
    <div className="order-detail">
      {view.map(component => (
        <UXComponentRenderer {...component} />
      ))}
      {membershipDiscount?.total > 0 && (
        <div className="membership-discount">
          <span>
            You're saving ${parseFloat(membershipDiscount.total).toFixed(2)} on
            this order with Unity Pass!
          </span>
        </div>
      )}
      {isUserEligibleForMembership && membershipStatus === 'non-member' && (
        <div className="membership-upselling-banner">
          <div className="description-container">
            <span>Get free delivery and more - save on average $60/month</span>
            <b style={{ marginTop: '14px' }}>
              <span className="join-now" onClick={openMembershipCheckoutModal}>
                Join Now and Save
              </span>
            </b>
          </div>
          <div className="golden-triangle" />
          <div className="unity-pass-banner" />
        </div>
      )}
      <SubscriptionPriceRenewalInfoBanner />
    </div>
  )
}
